<template>
  <li class="composition-product" :class="{ 'has-link': detailLink }" @click="goProductDetail">
    <div class="product-thumbnail">
      <img :src="product.course ? product.course.desktopCardAssetUrl : productThumbImgUrl" alt="" />
    </div>
    <div class="product-desc">
      <span class="product-desc__title">{{ product.title }}</span>
      <span class="product-desc__price">현재 판매가 {{ product.listPrice | numeric }}원</span>
    </div>
  </li>
</template>

<script>
export default {
  props: ['product'],
  data() {
    return {
      productThumbImgUrl:
        'https://storage.googleapis.com/static.fastcampus.co.kr/prod/uploads/202102/154347-319/layout-906-product-thumb.png',
    };
  },
  computed: {
    detailLink() {
      return this.product.course?.slug;
    },
  },
  methods: {
    goProductDetail() {
      if (!this.detailLink) return;
      window.open('/' + this.detailLink);
    },
  },
};
</script>
